(function () {
  'use strict';

  if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-list-collections')) {
    return;
  }

  var SEL_WRAP = '.dw-collection-intro-wrap';
  var SEL_INTRO = '.dw-collection-intro';
  var SEL_TOGGLE = '.dw-collection-intro-toggle';
  var SEL_MORE = '.dw-collection-intro-toggle__more';
  var SEL_LESS = '.dw-collection-intro-toggle__less';

  function isTruncated(intro) {
    return intro.scrollHeight > intro.clientHeight + 1;
  }

  function syncToggle(wrap) {
    var intro = wrap.querySelector(SEL_INTRO);
    var toggle = wrap.querySelector(SEL_TOGGLE);
    if (!intro || !toggle) return;

    var expanded = intro.classList.contains('dw-collection-intro--expanded');
    var more = toggle.querySelector(SEL_MORE);
    var less = toggle.querySelector(SEL_LESS);

    if (expanded) {
      toggle.hidden = false;
      wrap.classList.add('dw-collection-intro-wrap--truncated');
      return;
    }

    var truncated = isTruncated(intro);
    wrap.classList.toggle('dw-collection-intro-wrap--truncated', truncated);
    toggle.hidden = !truncated;

    if (!truncated) {
      toggle.setAttribute('aria-expanded', 'false');
      if (more) more.hidden = false;
      if (less) less.hidden = true;
    }
  }

  function setExpanded(wrap, expanded) {
    var intro = wrap.querySelector(SEL_INTRO);
    var toggle = wrap.querySelector(SEL_TOGGLE);
    if (!intro || !toggle) return;

    var more = toggle.querySelector(SEL_MORE);
    var less = toggle.querySelector(SEL_LESS);

    intro.classList.toggle('dw-collection-intro--expanded', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (more) more.hidden = expanded;
    if (less) less.hidden = !expanded;

    if (!expanded) syncToggle(wrap);
  }

  function initWrap(wrap) {
    syncToggle(wrap);

    var toggle = wrap.querySelector(SEL_TOGGLE);
    if (!toggle || toggle.dataset.dwIntroBound) return;
    toggle.dataset.dwIntroBound = 'true';

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setExpanded(wrap, !expanded);
    });
  }

  function refreshAll() {
    document.querySelectorAll(SEL_WRAP).forEach(function (wrap) {
      var intro = wrap.querySelector(SEL_INTRO);
      if (intro && !intro.classList.contains('dw-collection-intro--expanded')) {
        syncToggle(wrap);
      }
    });
  }

  function init() {
    document.querySelectorAll(SEL_WRAP).forEach(initWrap);
    refreshAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', refreshAll);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshAll, 150);
  });
})();
